<template>
  <div class="common-overlay" :class="{'bg-gray' : isGray}" @click.stop="handleOverlayClick">
    <div @click.stop>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonOverlay',
  props: {
    isGray: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleOverlayClick(event) {
      this.$emit('handleOverlayClick', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.common-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: $shadowBlack_50;
  z-index: 9999;
  &.bg-gray{
    background-color: rgba(161, 161, 161, 0.5);
  }
}
</style>
